module.exports = __webpack_public_path__ + "img/foreplay-api-icon.6cf105d4.svg";